import React from 'react';
import { Route } from 'react-router-dom';
import TransportAddStudent from '@/pages/transport/AddStudent';
import RouteSetting from '@/pages/transport/RouteSetting';
import TransportFeePayment from '@/pages/transport/FeePayment';
import TransportType from '@/pages/transport/TransportType';
import TransportSetting from '@/pages/transport/TransportSetting';
import DriverSetting from '@/pages/transport/DriverSetting';
import TransportStudentLedger from '@/pages/transport/StudentLedger';
import TransportFeeReport from '@/pages/transport/FeeReport';
import TransportClearance from '@/pages/transport/TransportClearance';

export const transportRoutes = (
  <React.Fragment>
    <Route path="transport/add-student" element={<TransportAddStudent />} />
    <Route path="transport/route-setting" element={<RouteSetting />} />
    <Route path="transport/fee-payment" element={<TransportFeePayment />} />
    <Route path="transport/type" element={<TransportType />} />
    <Route path="transport/setting" element={<TransportSetting />} />
    <Route path="transport/driver-setting" element={<DriverSetting />} />
    <Route path="transport/student-ledger" element={<TransportStudentLedger />} />
    <Route path="transport/fee-report" element={<TransportFeeReport />} />
    <Route path="transport/clearance" element={<TransportClearance />} />
  </React.Fragment>
);
